import wordPreview from './src/main'

wordPreview.install = function (Vue) {
  Vue.component(wordPreview.name, wordPreview)
}

export default wordPreview
